import { SET_ERROR } from "../actions/errorActions";
import { CONFIGURATION_LOADED } from "../actions/configurationActions";
import { RESET_FOR_MODEL_SELECTOR } from "../actions/sessionActions";
import ErrorState from "../stateTypes/errorState";

const initialState: ErrorState = {
    error: null,
};

const errorReducer = (state: ErrorState = initialState, action: any = {}) => {
    switch (action.type) {
        case SET_ERROR:
            return {
                ...state,
                error: action.error,
            };
        case RESET_FOR_MODEL_SELECTOR:
            return state;
        case CONFIGURATION_LOADED:
            return { ...state, error: null };
        default:
            return state;
    }
};

export default errorReducer;
